export default "__VITE_ASSET__VXCU0Hcz__"